import { render, staticRenderFns } from "./StoreRestDayApply.vue?vue&type=template&id=6ed9ab28&scoped=true&"
import script from "./StoreRestDayApply.vue?vue&type=script&lang=js&"
export * from "./StoreRestDayApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed9ab28",
  null
  
)

export default component.exports